export default __webpack_public_path__ + "static/media/construction-bg.162a06b7.webp";